import {useDictionary, useItems} from '@adamlip/okeoke.client'
import {useEffect, useState} from 'react'
import SizeGroup from './SizeGroup'
import toast from 'react-hot-toast'
import BarSoftButton from 'components/_NewComponents/BarSoftButton'
import SelectedMenuSizeConfiguration from 'components/Modals/MenuSelectModal/MenuOptionsSelector/SelectedMenuSizeConfiguration'

export default function MenuOptionsSelector({selectedSize, addToBasket, setSizeGroupsValidation, selectedAssembledItems, selectedAssembledItem, setSelectedAssembledItem}) {
	const {getValue} = useDictionary()
	const {sizeGroups, sizeConnections} = useItems()

	const [selectedSizeGroups, setSelectedSizeGroups] = useState([])
	const [activeGroup, setActiveGroup] = useState(0)
	const [disableNext, setDisableNext] = useState(true)
	const getSelectedMembers = (groupUUID) => {
		return selectedAssembledItems.current?.[groupUUID] || {}
	}

	const handleSetMenuItem = (item) => {
		//console.log(item)
		setSelectedAssembledItem(item)
	}

	const addSelectedItem = (assembledItem) => {
		const {minSelect, maxSelect} = sizeGroups?.[assembledItem?.sizeGroupUUID] || {}

		const {count: oldCount} = selectedAssembledItems.current?.[assembledItem.sizeGroupUUID]?.[assembledItem.selectedSizeUUID] || {count: 0}

		const {count: newCount} = assembledItem

		let groupTotalCount = Object.values(selectedAssembledItems.current?.[assembledItem.sizeGroupUUID] || {}).reduce((acc, curr) => acc + (curr?.count || 0), 0)

		if (minSelect === 1 && maxSelect === 1) {
			if (assembledItem?.count < 1) {
				toast.error(getValue('app_v2_menu_cant_remove'))
			} else {
				selectedAssembledItems.current = {
					...selectedAssembledItems.current,
					[assembledItem.sizeGroupUUID]: {
						[assembledItem.memberUUID]: assembledItem,
					},
				}
			}
		} else {
			let canAdd = true
			if (newCount > oldCount && maxSelect !== 0 && groupTotalCount - oldCount + newCount > maxSelect) {
				toast.error(getValue('app_v2_menu_cant_add_more'))
				canAdd = false
			}
			if (newCount < oldCount && minSelect !== 0 && groupTotalCount === 1) {
				toast.error(getValue('app_v2_menu_cant_remove'))
				canAdd = false
			}
			if (canAdd) {
				selectedAssembledItems.current = {
					...selectedAssembledItems.current,
					[assembledItem.sizeGroupUUID]: {
						...selectedAssembledItems.current[assembledItem.sizeGroupUUID],
						[assembledItem.memberUUID]: assembledItem,
					},
				}
			}
		}
	}

	useEffect(() => {
		if (selectedSize && sizeConnections) {
			if (sizeConnections?.[selectedSize?.uuid]?.g) {
				let groups = sizeConnections?.[selectedSize?.uuid]?.g?.sort((a, b) => a.idx - b.idx)?.map((group) => sizeGroups?.[group.uuid])
				setSelectedSizeGroups(groups)
			}
		}
	}, [selectedSize, sizeConnections, sizeGroups])

	return (
		<div className='flex flex-col h-full w-full pb-2 grow overflow-hidden'>
			{selectedAssembledItem == null && (
				<div className='w-full flex flex-col gap-2 items-center justify-center py-4 pt-0  overflow-y-scroll'>
					<SelectedMenuSizeConfiguration
						itemUUID={selectedSize.itemUUID}
						selectedSizeUUID={selectedSize.uuid}
						valid={selectedAssembledItem?.valid}
						disabled={selectedAssembledItem == null}
						menuItemParams={{
							onAdd: handleSetMenuItem,
							defaultCount: 1,
							minSelect: 1,
							maxSelect: 1,
							selectedSizeUUID: selectedSize.uuid,
							price: selectedSize.price,
							selected: selectedAssembledItem != null,
							hideCounter: true,
						}}
					/>
				</div>
			)}
			{selectedSizeGroups?.filter((group) => group.enabled)?.length < 1 && <div className='font-bold text-lg text-danger w-full text-center py-6 px-2'>{getValue('app_v2_menu_no_available_groups')}</div>}
			{selectedAssembledItem !== null && selectedSizeGroups?.filter((group) => group.enabled)?.length > 0 && (
				<div className='w-full h-full flex flex-col gap-1 overflow-hidden'>
					<div className='w-full flex flex-col gap-2 overflow-hidden'>
						<SizeGroup
							key={selectedSizeGroups?.filter((group) => group.enabled)?.[activeGroup]?.uuid}
							group={selectedSizeGroups?.filter((group) => group.enabled)?.[activeGroup]}
							setSizeGroupsValidation={setSizeGroupsValidation}
							addSelectedItem={addSelectedItem}
							getSelectedMembers={getSelectedMembers}
							disableNext={setDisableNext}
							setDisableNext={setDisableNext}
							activeGroup={activeGroup}
						/>
					</div>
					<div className='w-full px-2 flex flex-col gap-2'>
						{activeGroup === selectedSizeGroups?.filter((group) => group.enabled)?.length - 1 ? (
							<BarSoftButton onPress={() => addToBasket()} isDisabled={selectedAssembledItem == null || (activeGroup === selectedSizeGroups?.filter((group) => group.enabled)?.length - 1 && disableNext)} color='primary'>
								{selectedAssembledItem == null ? getValue('app_v2_menu_no_menuSize_selected') : disableNext ? getValue('app_v2_menu_disableNext') : getValue('app_v2_menu_to_basket')}
							</BarSoftButton>
						) : (
							<BarSoftButton onPress={() => setActiveGroup(activeGroup + 1)} isDisabled={disableNext || activeGroup === selectedSizeGroups?.filter((group) => group.enabled)?.length - 1}>
								{disableNext ? getValue('app_v2_menu_disableNext') : getValue('app_v2_menu_next')}
							</BarSoftButton>
						)}
						{activeGroup > 0 && (
							<BarSoftButton onPress={() => setActiveGroup(activeGroup - 1)} color='primary' variant='bordered' forceCustom={true}>
								{getValue('app_v2_menu_previous')}
							</BarSoftButton>
						)}
						{activeGroup == 0 && selectedAssembledItem !== null && (
							<BarSoftButton onPress={() => setSelectedAssembledItem(null)} color='primary' variant='bordered' forceCustom={true}>
								{getValue('app_v2_menu_previous')}
							</BarSoftButton>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
